import React, { useState, useEffect } from "react";
import { uploadPreview } from "../../../utils/constants";
import {
  BiCopy,
  BiLogoGoogle,
  BiLogoLinkedin,
  BiLogoMicrosoft,
  BiLogoMicrosoftTeams,
  BiLogoSlack,
  BiLogoWhatsapp,
  BiMailSend,
} from "react-icons/bi";
import ReactTooltip from "react-tooltip";
import {
  Button,
  Col,
  Row,
  FormGroup,
  Popover,
  PopoverHeader,
  PopoverBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import SlackSharePopup from "../../../components/SlackAndTeamsPopups/SlackSharePopup";
import TeamsSharePopup from "../../../components/SlackAndTeamsPopups/TeamsSharePopup";
import { baseUrl } from "../../../utils/constants";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import Select from "react-select/lib/Select";
import Tooltip from "../../../components/UI/TooltipIcon/TooptipIcon";
import { data } from "jquery";
import { getTriviaFileName, TRIVIA_LIB_PRIVACY_OPTIONS } from "../data";

export default function UpdateLibraryModal({
  open,
  onClose,
  onUpdateSuccess,
  libraryData,
  isToolkit = true,
}) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [privacy, setPrivacy] = useState(libraryData.status);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [updatedFields, setUpdatedFields] = useState({
    privacy: false,
    file: false,
  });

  const formatSelectedUsers = (data) => {
    const d = data.map((e) => {
      if (e.firstName && e.lastName) {
        return {
          label: `${e.firstName}, ${e.lastName}`,
          value: e._id || e.userId,
        };
      } else if (e) {
        let name =
          e.firstName && e.firstName.length > 0 ? e.firstName : e.lastName && e.lastName.length > 0 ? e.lastName : e.email
        return { label: `${name}`, value: e._id || e.userId };
      }
    });

    return d;
  };

  const shouldEdit = () => {
    let disabled = false;
    if (libraryData && uploadedFile) {
      //  if (
      //    JSON.stringify(selectedUsers) ==
      //    JSON.stringify(formatSelectedUsers(libraryData.selectedUsers))
      //  ) {
      //    console.log("1-------------");
      //    disabled = true;
      //  }

      if (privacy === libraryData.status) {
        disabled = true;
      }

      if (!updatedFields.file && !updatedFields.privacy) {
        disabled = true;
      }
      return disabled;
    }
  };

  useEffect(() => {
    formatUrlToFile();
    if (libraryData.status === "CUSTOM") {
      if (libraryData.selectedUsers && libraryData.selectedUsers.length) {
        setSelectedUsers(formatSelectedUsers(libraryData.selectedUsers));
      }
    }
  }, []);

  const getUserList = () => {
    axios
      .get(url.userListArray)
      .then((response) => {
        setUsersData(response.data.data);
        const users = formatSelectedUsers(response.data.data);

        setUsersList(users);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getUserList();
  }, []);

  const fileSelectedHandler = (e) => {
    setUpdatedFields({ ...updatedFields, file: true });
    const file = e.target.files[0];
    // console.log('file: ', file)
    let obj = {
      name: file.name,
      type: file.type,
      size: file.size,
      file,
      datetime: Date.now().toString(),
      // blob: URL.createObjectURL(file),
      preview: URL.createObjectURL(file),
    };
    setUploadedFile(uploadPreview(obj));
  };

  const formatUrlToFile = () => {
    const ext = libraryData.s3Url.split(".")[
      libraryData.s3Url.split(".").length - 1
    ];
    let obj = {
      name: getTriviaFileName({
        uploadUrl: libraryData.s3Url,
        uploadedFileName: libraryData.fileUploadName,
        librarySourceType:libraryData.librarySourceType,
        libName:libraryData.name,
        webUrl:libraryData.webUrl

      }),
      type:
        ext === "pdf"
          ? { ext: "pdf", mime: "application/pdf" }
          : ["doc", "docx"].includes(ext)
          ? { ext: "doc", mime: "application/msword" }
          : ext === "txt"
          ? { ext: "txt", mime: "plain/text" }
          : null,
      size: null,
      file: null,

      preview: libraryData.s3Url,
    };
    setUploadedFile(uploadPreview(obj));
    setUpdatedFields({ ...updatedFields, file: false });
  };

  useEffect(() => {
    if (privacy === libraryData.privacy) {
      setUpdatedFields({ ...updatedFields, privacy: false });
    } else {
      setUpdatedFields({ ...updatedFields, privacy: true });
    }
  }, [privacy]);

  const handleOptionChange = (val) => {
    // console.log(changeEvent.target)
    // if (changeEvent.target.value === "ENTERPRISE") {
    //   setPrivacy("ENTERPRISE");
    // } else if (changeEvent.target.value === "CUSTOM") {
    //   setPrivacy("CUSTOM");
    // } else {
    //   setPrivacy("PRIVATE");
    // }
    setPrivacy(val.value);
  };

  const renderUploadPreview = () => {
    let photo = uploadedFile;
    let { preview, size } = photo;
    preview = preview != null && preview != undefined ? preview : photo.url;
    let mb = 1024 * 1024;
    let file_size =
      size >= mb
        ? `${(size / mb).toFixed(2)}mb`
        : `${(size / 1024).toFixed(2)}kb`;
    return (
      <span
        className={
          photo.isAccepted == false
            ? "taskUploadPreviewImg rejectedFilesContainer"
            : "taskUploadPreviewImg"
        }
      >
        <img src={preview} className="fileUploadSize" />
        {/* {photo.isMsIcon?
        <div classaName="imageUploadBlobSrc">
            <iframe src={preview} class="imgBlobSrc" scrolling="no" scroll="no" />
        </div>
        :
        <img src={preview}  className="fileUploadSize"/>
        } */}

        <span
          onClick={() => setUploadedFile(null)}
          className="removeTaskUpload"
        >
          <span className="flaticon-trash" />
        </span>
        <div className="previewTaskImageText">
          <span className="">{photo.name}</span>
          {/*<span className="previewTaskImageTitle">{file_size}</span>*/}
          {/* {photo.isAccepted==false?
            <span className="previewUploadFileError">
              The following file will not be uploaded because of its file type
            </span>
            :null} */}
        </div>
      </span>
    );
  };

  const callApiToSaveData = () => {
    const users_share = selectedUsers.map((itm) => {
      const user = usersData.find((x) => x._id == itm.value);

      if (user) {
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user._id,
          date: new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
        };
      } else {
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: "",
        };
      }
    });

    let payload = {};

    const triviaForm = new FormData();

    if (uploadedFile && updatedFields.file) {
      triviaForm.append("document", uploadedFile.file);
    }

    if (updatedFields.privacy) {
      payload = {
        selectedUsers: users_share,
        status: privacy,
      };
    }

    triviaForm.append("payload", JSON.stringify(payload));

    axios
      .put(url.updateTriviaLibraryDoc(libraryData._id), triviaForm)
      .then((res) => {
        const d = res.data.data;
        onUpdateSuccess(d);
      })
      .catch((err) => console.log(err));
  };
  return (
    <div>
      <Modal isOpen={open}>
        <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>Upload Documents To Library</ModalHeader>
        <ModalBody className={"p-3 "}>
          <div className="mt-5 px-5">
            <div className="fonnt-weight-bold my-3">
              <b>Upload Document</b>
            </div>
            {uploadedFile && renderUploadPreview()}
            <div className="singleTaskUploadModalBtn">
              <label
                htmlFor="profile-pic-file-input"
                style={{ marginBottom: "0px" }}
              >
                <span
                  className={`actionsByStatus ${
                    isToolkit ? "upload_file_toolkit" : "singleTaskUpload"
                  }`}
                >
                  <span className="flaticon-upload" />
                  Choose File
                </span>
              </label>
              <input
                id="profile-pic-file-input"
                onChange={fileSelectedHandler}
                type="file"
                accept=".doc,.DOC,.docx,.DOCX,.pdf,.PDF,.txt"
              />

              <a
                onClick={() => {
                  formatUrlToFile();
                }}
                className="text-info ml-3 underline cursor-pointer"
              >
                Keep Original
              </a>
            </div>
          </div>

          <div className="mx-5">
            <div className="mt-3 share-quiz-privacy">
              <b className="mt-2">Document Privacy:</b>

              <div className="mt-3">
                {/* <Row>
                  <Col>
                    <div className="radio ml0 mt-3">
                      <input
                        id="meRadio"
                        name="meRadio"
                        onChange={handleOptionChange}
                        type="radio"
                        value="PUBLIC"
                        checked={privacy === "PRIVATE"}
                      />
                      <label
                        htmlFor="meRadio"
                        className="radio-label benchmark-radio-label benchmark-display-name ml-2"
                      >
                        Only Me
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="radio ml0 mt-3">
                      <input
                        id="enterpriseRadio"
                        name="enterpriseRadio"
                        onChange={handleOptionChange}
                        type="radio"
                        value="ENTERPRISE"
                        checked={privacy === "ENTERPRISE"}
                      />
                      <label
                        htmlFor="enterpriseRadio"
                        className="radio-label benchmark-radio-label benchmark-display-name ml-2"
                      >
                        Enterprise
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="radio ml0 mt-3">
                      <input
                        id="customRadio"
                        name="customRadio"
                        onChange={handleOptionChange}
                        type="radio"
                        value="CUSTOM"
                        checked={privacy === "CUSTOM"}
                      />
                      <label
                        htmlFor="customRadio"
                        className="radio-label benchmark-radio-label benchmark-display-name ml-2"
                      >
                        Invite Specific Users
                      </label>
                    </div>
                  </Col>
                </Row> */}

                <Select
                  className="pt-0 mb-3"
                  value={privacy}
                  onChange={(val) => {
                    handleOptionChange(val);
                  }}
                  options={TRIVIA_LIB_PRIVACY_OPTIONS}
                  placeholder="Select Privacy"
               
                />

                {privacy === "CUSTOM" ? (
                  <FormGroup className={"mt40"} row>
                    <Col sm={9} md={9} lg={9} className="pl-5">
                      <FormGroup className="" row>
                        <Col sm={9} md={9} className="align-self-center px-0">
                          <Select
                            isMulti={true}
                            multi={true}
                            name="user-select"
                            placeholder={"Select users to share this quiz with"}
                            value={
                              selectedUsers && selectedUsers.length > 0
                                ? selectedUsers
                                : ""
                            }
                            isOpen={true}
                            options={usersList}
                            onChange={(itm) => setSelectedUsers(itm)}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </FormGroup>
                ) : null}
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="mr-4 trivia-action-button-main"
            onClick={callApiToSaveData}
            disabled={shouldEdit()}
          >
            Update
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
